export interface Bonus {
  number: string
  title: string
  /** One short line: what it does for the teacher. */
  promise: string
  /** Three short chips — the contents at a glance. */
  tags: string[]
  pages: string
  value: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'The First Week Art Flow Kit™',
    promise: 'Walk into day one with the whole first week already planned.',
    tags: ['5 first-week lessons', 'Student worksheets', 'Gallery walk guide'],
    pages: '16 pages',
    value: '$19.00',
    image:
      'https://cdn.magicpatterns.com/uploads/hGi7fkLLLyUZzH1msBtUEt/ChatGPT_Image_16_sept_2026,_00_30_12.webp',
    alt: 'Bonus 1 cover: The First Week Art Flow Kit',
  },
  {
    number: '2',
    title: '365 Art Starter Prompts™',
    promise: 'One 5-minute warm-up for every single day of the year.',
    tags: ['365 daily prompts', 'Sorted by month', 'Project or print'],
    pages: '20 pages',
    value: '$12.00',
    image:
      'https://cdn.magicpatterns.com/uploads/otZmE2YPBQqtqneRrFpwYj/ChatGPT_Image_16_sept_2026,_00_31_07.webp',
    alt: 'Bonus 2 cover: 365 Art Starter Prompts',
  },
  {
    number: '3',
    title: 'The No-Prep Art Project Menu™',
    promise: 'Pick the right project in 60 seconds — by time and materials.',
    tags: ['20 / 45 / 90 min', 'By materials on hand', 'Zero-supply options'],
    pages: '18 pages',
    value: '$15.00',
    image:
      'https://cdn.magicpatterns.com/uploads/d53AhEGFuTAFAhSgdkse7R/ChatGPT_Image_16_sept_2026,_00_32_00.webp',
    alt: 'Bonus 3 cover: The No-Prep Art Project Menu',
  },
  {
    number: '4',
    title: 'The Student Art Reflection Journal™',
    promise: 'Turn every finished piece into visible learning.',
    tags: ['Reflection sheets', 'Artist statements', 'Peer feedback'],
    pages: '18 pages',
    value: '$12.00',
    image:
      'https://cdn.magicpatterns.com/uploads/777tUgbVd29abTHahqYK9L/ChatGPT_Image_16_sept_2026,_00_33_00.webp',
    alt: 'Bonus 4 cover: The Student Art Reflection Journal',
  },
  {
    number: '5',
    title: 'The Low-Budget Material Swap Guide™',
    promise: 'Teach the same lesson beautifully with an empty supply closet.',
    tags: ['Substitution charts', 'Pencil-only projects', 'Recycled materials'],
    pages: '16 pages',
    value: '$14.00',
    image:
      'https://cdn.magicpatterns.com/uploads/d6VsGUqFXAztUy8zd5WqfL/ChatGPT_Image_16_sept_2026,_00_33_45.webp',
    alt: 'Bonus 5 cover: The Low-Budget Material Swap Guide',
  },
  {
    number: '6',
    title: 'The Projectable Art Instruction Slides™',
    promise: 'Project the steps and let students work without asking twice.',
    tags: ['Drawing & painting steps', 'Composition guides', '3D thinking'],
    pages: '20 pages',
    value: '$13.00',
    image:
      'https://cdn.magicpatterns.com/uploads/1YuPNCswrXHDvujHJAgCes/ChatGPT_Image_16_sept_2026,_00_34_53.webp',
    alt: 'Bonus 6 cover: The Projectable Art Instruction Slides',
  },
]

/** Short labels used on the value-stack table. */
export const bonusValueStack: Array<{ label: string; value: string }> = [
  { label: 'First Week Kit™', value: '$19.00' },
  { label: '365 Starter Prompts™', value: '$12.00' },
  { label: 'Project Menu™', value: '$15.00' },
  { label: 'Reflection Journal™', value: '$12.00' },
  { label: 'Material Swap Guide™', value: '$14.00' },
  { label: 'Instruction Slides™', value: '$13.00' },
]
